import { createContext, useContext } from "react";
import type { JourneyController } from "./useQuoteJourneyController";
import type { JourneyPage, JourneyPageKey } from "./quoteJourneyState";
import type { JourneyEditor } from "./quoteJourneyLeave";
export type JourneyBlockerOptions = { settingsOnly?: boolean };
export type QuoteJourneyAccess = {
  notice: string | null;
  controller: JourneyController;
  suspended: boolean;
  restoredPage: (key: JourneyPageKey) => JourneyPage | null;
  consumePage: (key: JourneyPageKey) => void;
  registerPage: JourneyController["registerPage"];
  registerBlocker: (
    id: string,
    reason: () => string | null,
    options?: JourneyBlockerOptions,
  ) => () => void;
  registerEditor: (id: string, editor: JourneyEditor) => () => void;
  requestEditorLeave: (id: string | readonly string[]) => Promise<boolean>;
};
export const QuoteJourneyContext = createContext<QuoteJourneyAccess | null>(
  null,
);
export const useQuoteJourney = () => useContext(QuoteJourneyContext);
